module.exports = __webpack_public_path__ + "media/images/lp/donation4-title-pc-1446043cf64917959d751fa190965dcc.png";